var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"open-source-refer"},on:{"click":function($event){return _vm.goToGithub()}}},[_c('p',[_vm._v("This project is open source!")]),_c('div',{staticClass:"contribute"},[_vm._v("Contribute")])])}
var staticRenderFns = []

export { render, staticRenderFns }